import { Text, Container, List, ListItem, ListIcon, Link } from '@chakra-ui/layout';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export default function DMCA(){
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return(
        <div>
            <Container maxW={["90%", "90%", "90%", "80%"]} mb={12} mt={"40px"}  p={[0, 0, 0, 4]}>
                <Text fontSize="2xl" fontWeight="900">
                    PROXIMY TECHNOLOGIES INC.
                </Text>
                <Text fontSize="1xl" fontWeight="900">
                    DMCA Policy
                </Text>
                <Text fontSize="1xl" mt="20px">
                    If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement and is accessible via the Site and/or the Provider Materials (as defined in the Proximy Technologies Inc. <Link><RouterLink to="/">"Terms of Use"</RouterLink></Link>, please notify Proximy’s designated copyright agent, as provided in the Digital Millennium Copyright Act of 1998 ("DMCA"). For your complaint to be valid under the DMCA, you must provide us with the following information in writing:<br/><br/>

                    1.	An electronic or physical signature of a person authorized to act on behalf of the legal copyright owner;<br/>
                    2.	Identification of the copyrighted work that you claim has been infringed;<br/>
                    3.	Identification of the material that is claimed to be infringing and where it is located on the Site and/or Provider Materials (including the relevant URL, as applicable);<br/>
                    4.	Information reasonably sufficient to enable Proximy contact you, such as address, telephone number, and e-mail address of you or your legal representative;<br/>
                    5.	A statement confirming that you have a good faith belief that use of the material in the manner of which you are complaining has not been authorized by the legal copyright owner, its agent or applicable law; and<br/>
                    6.	A statement, made under penalty of perjury, that the above information is accurate and that you are the legal copyright owner or are authorized to act on behalf of the legal owner.<br/><br/>

                    The above information must be submitted to the following DMCA Agent:<br/><br/>

                    Attn: DMCA Notices<br/>
                    Proximy Technologies Inc.<br/>
                    301-1665 Ellis Street, Kelowna, BC Canada V1Y 2B3<br/>
                    Fax: 250-762-6665<br/>
                    info@proximy.ca<br/><br/>

                    UNDER APPLICABLE UNITED STATES FEDERAL LAW, IF YOU KNOWINGLY MISREPRESENT THAT ONLINE MATERIAL IS INFRINGING, YOU MAY BE SUBJECT TO CRIMINAL PROSECUTION FOR PERJURY AND CIVIL PENALTIES, INCLUDING MONETARY DAMAGES, COURT COSTS AND ATTORNEYS’ FEES.<br/><br/>


                    Please note that this procedure is exclusively for notifying Proximy that your copyrighted material has been infringed. The foregoing requirements are intended to comply with Proximy's rights and obligations under the DMCA, including 17 U.S.C. §512(c), but do not constitute, and should not be construed as, legal advice. We strongly recommend that your seek competent legal advice concerning your rights and obligations under the DMCA and other applicable laws.
                </Text>

            

            </Container>
        </div>
    )
}